import configuration from '~/configuration';

let notifications = [];
let logs = [];
let errors = [];

const _consoleError = console.error;
console.error = (...args) => {
  errors.push({
    t: new Date(),
    m: args,
  });

  _consoleError(...args);
};

const _consoleLog = console.log;
console.log = (...args) => {
  logs.push({
    t: new Date(),
    m: args,
  });

  _consoleLog(...args);
};

_consoleLog('Console monitoring initialized');

export default {
  addNotification: (notification) => {
    notifications.push(notification);
  },
  summary: () => {
    return {
      userAgent: navigator.userAgent,
      app: configuration.version,
      notifications,
      logs,
      errors,
    };
  },
};
